module.exports = __webpack_public_path__ + "img/tb.e867bb8d.jpg";